import React from "react";
import { useTranslation } from "react-i18next";

export default function Shipping() {
  const { t } = useTranslation();
  return (
    <div>
      <h1 className="text-4xl font-bold mb-6">{t('shipping.title')}</h1>

      <div className="prose dark:prose-invert space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            {t('shipping.methodsTitle')}
          </h2>

          <div className="space-y-4">
            <div className="border border-raya-border rounded-lg p-4">
              <h3 className="font-semibold mb-2">🚚 {t('shipping.standard')}</h3>
              <p className="text-raya-text-primary/90 font-medium mb-2">
                {t('shipping.standardTime')}
              </p>
              <p className="text-raya-text-primary/90 font-medium">
                <strong>Cost:</strong> {t('shipping.standardCost')}
              </p>
            </div>

            <div className="border border-raya-border rounded-lg p-4">
              <h3 className="font-semibold mb-2">📦 {t('shipping.expedited')}</h3>
              <p className="text-raya-text-primary/90 font-medium mb-2">
                {t('shipping.expeditedTime')}
              </p>
              <p className="text-raya-text-primary/90 font-medium">
                <strong>Cost:</strong> {t('shipping.expeditedCost')}
              </p>
            </div>

            <div className="border border-raya-border rounded-lg p-4">
              <h3 className="font-semibold mb-2">⚡ {t('shipping.overnight')}</h3>
              <p className="text-raya-text-primary/90 font-medium mb-2">
                {t('shipping.overnightTime')}
              </p>
              <p className="text-raya-text-primary/90 font-medium">
                <strong>Cost:</strong> {t('shipping.overnightCost')}
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('shipping.processingTitle')}</h2>
          <p className="text-raya-text-primary/90 font-medium mb-4">
            {t('shipping.processingText')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">
            {t('shipping.internationalTitle')}
          </h2>
          <p className="text-raya-text-primary/90 font-medium mb-4">
            {t('shipping.internationalText')}
          </p>
        </section>
      </div>
    </div>
  );
}
